import styled from 'styled-components'

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9950;
`

export const ModalContainer = styled.div`
  background-color: #ffffff;
  border-radius: 16px;
  padding: 40px 32px;
  max-width: 400px;
  width: 90%;
  text-align: center;

  @media (max-width: 768px) {
    padding: 32px 24px;
  }
`

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
`

export const Title = styled.h2`
  font-size: 18px;
  font-weight: 700;
  color: #303030;
  margin: 0 0 12px 0;
  line-height: 1.4;
`

export const Description = styled.p`
  font-size: 14px;
  color: #696969;
  margin: 0 0 32px 0;
  line-height: 1.6;
`

export const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;

  @media (max-width: 768px) {
    flex-direction: column-reverse;
  }
`

export const CloseButton = styled.button`
  background-color: #ffffff;
  color: #0090d3;
  border: 1px solid #0090d3;
  padding: 12px 32px;
  border-radius: 100px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
`

export const ReportButton = styled.button`
  background-color: #0090d3;
  color: white;
  border: none;
  padding: 12px 32px;
  border-radius: 100px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
`